import { PRODUCT_STATUS_V2 } from '../../../types/product';

export const PRODUCT_STATUS_LABEL_V2 = {
  [PRODUCT_STATUS_V2.CONFIRM_READY]: '승인 대기',
  [PRODUCT_STATUS_V2.CONFIRM_REJECT]: '승인 거절',
  [PRODUCT_STATUS_V2.NOW_ON_SALE]: '판매 중',
  [PRODUCT_STATUS_V2.SOLD_OUT]: '품절',
  [PRODUCT_STATUS_V2.SALES_CLOSE]: '판매 종료',
  [PRODUCT_STATUS_V2.SALES_PROHIBIT]: '판매 금지',
  [PRODUCT_STATUS_V2.SALES_READY]: '판매 대기',
  [PRODUCT_STATUS_V2.SALES_STOP]: '판매 중지',
  [PRODUCT_STATUS_V2.DELETE]: '상품 삭제',
};

export const PRODUCT_STATUS_SELECT_LIST_V2 = Object.values(PRODUCT_STATUS_V2).map((status) => ({
  id: status,
  name: PRODUCT_STATUS_LABEL_V2[status],
}));

/**
 * 상세 페이지 제작 가이드 PDS 다운로드 링크 주소
 * */
export const PRODUCT_DETAIL_GUIDE_DOWNLOAD_LINK =
  'https://drive.google.com/drive/u/0/folders/1fcfigBCvZ3lmq9yAKeSdvuFdh8x30q-3';

/**
 * 상품 상세 스크롤 네비게이터 - 페이지 하단 감지 임계값
 *
 * 마지막 섹션의 높이가 viewport보다 짧을 경우, 페이지 끝까지 스크롤해도
 * 해당 섹션의 offsetTop 조건을 만족하지 못하는 문제를 방지합니다.
 * 사용자가 페이지 하단 100px 이내에 도달하면 마지막 탭을 활성화합니다.
 */
export const SCROLL_NAVIGATOR_BOTTOM_THRESHOLD = 100;

/**
 * 상품 상세 스크롤 네비게이터 - 섹션 조기 활성화 오프셋
 *
 * 섹션이 화면 상단에 정확히 도달하기 전에 미리 탭을 활성화하여
 * 사용자가 실제로 해당 섹션을 보고 있다고 느끼는 시점과 탭 활성화 타이밍을 일치시킵니다.
 * 스크롤 시 더 자연스러운 UX를 제공합니다.
 */
export const SCROLL_NAVIGATOR_ACTIVATION_OFFSET = 50;
